// extracted by mini-css-extract-plugin
module.exports = {"parent":"blank_parent__hYQSg"};